import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_ROW,
  FLEX_DIRECTION_COLUMN,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  TEXT_DECORATION_NONE,
  DISPLAY_BLOCK,
  FLEX_JUSTIFY_START,
  FONT_SIZE_MD,
  FONT_WEIGHT_BOLD,
  BORDER_SECONDARY,
  FLEX_ALIGN_START,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const StudentDataStyled = styled("div")(({ theme }) => ({
  width: "100vw",
  "& .student-page-header": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 40px 24px 40px",
    marginLeft: "256px",
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: "12px 0px",
  },
  "& .nav-tabs": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_START,
    borderBottom: "none",
    listStyleType: "none",
    padding: "0px",
    gap: "1rem",
  },
  "& .nav-link": {
    display: DISPLAY_BLOCK,
    padding: "12px 16px",
    fontSize: FONT_SIZE_MD,
    fontWeight: FONT_WEIGHT_BOLD,
    textDecoration: "none",
    backgroundColor: colors.background,
    color: colors.nonActive,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.background.active,
      color: colors.primary,
    },
  },
  "& .tab-content": {
    marginTop: "24px",
    border: BORDER_SECONDARY,
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .tab-panel": {
    display: DISPLAY_BLOCK,
  },
  "& .upload-card": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    gap: "12px",
    alignItems: FLEX_ALIGN_START,
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_SECONDARY,
    padding: "16px",
    flex: 1,
    pointer: "cursor",
    textDecoration: TEXT_DECORATION_NONE,
    "&:hover": {
      backgroundColor: theme.palette.background.active,
      color: colors.primary,
    },
  },
  "& .student-upload-step": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: colors.disabled,
    },
  },
  "& .upload-templete-box": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_SECONDARY,
    padding: "16px",
    alignItems: FLEX_ALIGN_START,
    height: "72px",
    width: "90%",
    gap: "8px",
    marginBottom: "24px",
  },
  "& .upload-template-divider": {
    height: "2px",
    backgroundColor: colors.disabled,
    marginRight: "10px",
    marginLeft: "50px",
  },
  "& .download-link": {
    cursor: "pointer",
    textDecoration: "underline !important",
    color: "#402ca8 !important",
    fontSize: "14px",
  },
  "& .activity-inactive": {
    alignSelf: FLEX_ALIGN_CENTER,
    padding: "16px",
  },
  "& .primary-button-add": {
    width: "140px",
    height: "40px",
    ...theme.typography.body1,
    backgroundColor: colors.primary,
    color: theme.palette.secondary.contrastText,
    border: "none",
    "&:hover": {
      backgroundColor: colors.primary,
      color: theme.palette.secondary.contrastText,
    },
  },
  "& .primary-button-add-disable": {
    width: "140px",
    height: "40px",
    ...theme.typography.body1,
    backgroundColor: theme.palette.secondary.contrastText,
    color: colors.grayLight,
    border: "1px solid #7950ff",
    cursor: "not-allowed",
  },
  "& .clear-filter": {
    color: colors.primary,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    textDecoration: "underline",
  },
  "& .activity-status-container": {
    width: "35%",
    padding: "32px",
    borderLeft: BORDER_SECONDARY,
  },
  "& .download-failure-file": {
    ...theme.typography.body1,
    background: "none",
    border: "none",
    color: colors.primary,
  },
}));
